export default [
    {
        path: "/channel_list",
        name: "channel_list",
        meta: { title: "渠道列表" },
        component: () => import("@/views/channel/channel_list.vue"),
    },
    // {
    //     path: "/channel_add",
    //     name: "channel_add",
    //     meta: { title: "新增渠道" },
    //     component: () => import("@/views/channel/channel_add.vue"),
    // },
    // {
    //     path: "/channel_edit",
    //     name: "channel_edit",
    //     meta: { title: "编辑渠道" },
    //     component: () => import("@/views/channel/channel_edit.vue"),
    // },
    // {
    //     path: "/channel_detail",
    //     name: "channel_detail",
    //     meta: { title: "渠道详情" },
    //     component: () => import("@/views/channel/channel_detail.vue"),
    // },
];